module.exports = __webpack_public_path__ + "static/img/ltd-app.5c36120b.png";